import { useContext } from 'react'

import { AccountStateContext } from '../state/AccountProvider'
import type { AccountContext } from '../types'

export const useAccount = (): AccountContext => {
  const context = useContext(AccountStateContext)

  if (context === undefined) {
    throw new Error('useAccount must be used within AccountProvider')
  }

  return context
}
